import { machineTypeSchema } from "@packsize/schemas/machines";

export const LANTECH_CASE_SEALER_MACHINES_QUERY_KEY = [
	"machines",
	{ machineType: machineTypeSchema.enum.LantechCaseSealer },
] as const;
